import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const btvChannelCategoriesSlice = createAppSlice({
  name: 'btvChannelCategories',
  initialState,
  reducers,
});

export const { fetchBtvChannelCategories } = btvChannelCategoriesSlice.actions;

export default btvChannelCategoriesSlice.reducer;
